(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["viteinte-avantages"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.viteinte-avantages');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25 });

  sections.forEach(function (s) { observer.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viteinte-chiffres"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.vt-chiffres');
  if (!sections.length) return;

  var calme =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /*
    Le décompte : de 0 jusqu'au nombre affiché. Le texte final est relu dans
    le DOM plutôt que passé en réglage — un seul endroit décide de la valeur.
  */
  function compter(el) {
    var texte = el.textContent.trim();
    var m = texte.match(/^(\D*)(\d+)(\D*)$/);
    if (!m) return;

    var avant = m[1];
    var cible = parseInt(m[2], 10);
    var apres = m[3];
    if (!cible || cible > 100000) return;

    /* Largeur figée sur la valeur finale AVANT de commencer : « 5 » puis
       « 15 » n'occupent pas la même place, et la rangée sauterait à chaque
       image. */
    el.style.display = 'inline-block';
    el.style.minWidth = el.getBoundingClientRect().width + 'px';

    var duree = 900;
    var depart = null;

    function pas(t) {
      if (depart === null) depart = t;
      var avancement = Math.min((t - depart) / duree, 1);

      /* Ralentissement en fin de course : le chiffre se pose au lieu de
         s'arrêter net. */
      var eased = 1 - Math.pow(1 - avancement, 3);

      el.textContent = avant + Math.round(cible * eased) + apres;

      if (avancement < 1) requestAnimationFrame(pas);
    }

    el.textContent = avant + '0' + apres;
    requestAnimationFrame(pas);
  }

  function animer(section) {
    section.classList.add('is-visible');
    if (calme) return;
    Array.prototype.forEach.call(
      section.querySelectorAll('.vt-chiffres__nombre'),
      compter
    );
  }

  Array.prototype.forEach.call(sections, function (s) {
    s.classList.add('vt-chiffres--anim');
  });

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(sections, animer);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animer(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.35 }
  );

  Array.prototype.forEach.call(sections, function (s) {
    observer.observe(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viteinte-garantie"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.viteinte-garantie');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });

  sections.forEach(function (s) { observer.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viteinte-transformations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.viteinte-transformations');
  if (!sections.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Anime un nombre de 0 à sa valeur finale dans le texte de l'élément
  // (préserve tout ce qui entoure le nombre : "10 min", "100%", "Déjà 1000+…")
  function countUp(el, duration) {
    var original = el.textContent;
    var match = original.match(/\d+/);
    if (!match) return;

    var target = parseInt(match[0], 10);
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = Math.round(target * eased);
      el.textContent = original.replace(match[0], current);
      if (progress < 1) requestAnimationFrame(frame);
    }

    el.textContent = original.replace(match[0], '0');
    requestAnimationFrame(frame);
  }

  // Remplit le camembert de 0 à sa valeur cible
  function fillDonut(donut, duration) {
    var target = parseFloat(donut.getAttribute('data-fill')) || 0;
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      donut.style.setProperty('--fill', (target * eased).toFixed(1));
      if (progress < 1) requestAnimationFrame(frame);
    }

    donut.style.setProperty('--fill', '0');
    requestAnimationFrame(frame);
  }

  function animate(section) {
    section.querySelectorAll('.viteinte-transformations__donut').forEach(function (donut) {
      fillDonut(donut, 1100);
      var value = donut.querySelector('[data-count]');
      if (value) countUp(value, 1100);
    });

    var title = section.querySelector('.viteinte-transformations__title[data-count]');
    if (title) countUp(title, 1400);
  }

  if (reduced || !('IntersectionObserver' in window)) return; // état final déjà en place

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  sections.forEach(function (s) { observer.observe(s); });
})();

  } catch(e) { console.error(e); }
})();
})();
